export const CHAT_GW_URL = import.meta.env.VITE_CHAT_GW_URL;
export const DEFAULT_HOME_SERVER = import.meta.env.VITE_DEFAULT_HOME_SERVER;
export const CHAT_APP_ID = import.meta.env.VITE_CHAT_APP_ID;
export const WS_URL = import.meta.env.VITE_WS_URL;
export const OUT_TIME = import.meta.env.VITE_OUT_TIME;
